<template>
  <div class="auth-modal">
    <!-- Modal Starts Here -->
    <div
      class="modal fade"
      id="addToMapModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addToMapModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header pb-0 border-0">
            <button id="dismissBtnNewTopic" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                <ion-icon name="ios-close" size="large"></ion-icon>
              </span>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-12 col-md-12 mb-3">
                  <h3 class="title mb-4">{{ coordinates ? 'Change Pin Location' : 'Pin To Map' }}</h3>
                    <div class="form-group">
                        <GmapMap :center="latLng" :options="mapOptions" style="height: 300px">
                            <GmapMarker ref="mapMarker" :position="latLng" :clickable="false" :draggable="true" @dragend="markerCallback($event)"/>
                        </GmapMap>
                        <small class="form-text text-muted mb-2">Use the marker to set the location on the map.</small>
                    </div>
                    
                    <div class="d-flex align-items-center justify-content-end">
                        <button v-if="coordinates" @click="removeLocation()" id="submitBtn" class="btn btn-danger text-white">Remove</button>
                        <button @click="done()" id="submitBtn" class="ml-3 btn btn-primary text-white">Done</button>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "AddToMap",
        props: ["coordinates"],
        data() {
            return {
                latLng: null,
                mapOptions: {
                    zoom: 7,
                    scrollWheel: false,
                    zoomControl: true,
                    disableDefaultUI: true,
                    scaleControl: false,
                    rotateControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    mapTypeId: this.$props.type || "terrain",
                },
            }
        },
        watch: {
            "$props.coordinates": {
                handler: function(val) {
                    if (val) {
                        this.latLng = val;
                    } else {
                        this.latLng = { lat: 9.0748812, lng: 7.465183 };
                    }
                },
                immediate: true,
                deep: true
            }
        },
        methods: {
            done() {
                const closeBtn = document.getElementById("dismissBtnNewTopic");
                this.$emit("locationSet", this.latLng);
                closeBtn.click();
            },
            removeLocation() {
                const closeBtn = document.getElementById("dismissBtnNewTopic");
                this.$emit("locationRemoved");
                this.latLng = { lat: 9.0748812, lng: 7.465183 };
                closeBtn.click();
            },
            markerCallback(e) {
                this.latLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            }
        }
    }
</script>

<style scoped lang="scss" src="../../Auth/AuthModal/AuthModal.scss"></style>